/*----------------------------------------------------------------------------*\
    NAV-TABS
    Tab navigation
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.navTabs = {
    init: function () {
        this.setup(document);
    },

    setup: function ($context) {
        var self = this;
        var $elements = $context.querySelectorAll('.js--nav-tabs');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupTab($element);
        }
    },


    setupTab: function ($element) {
        var $toggle = $element.querySelector('.js--nav-tabs__toggle');

        $toggle.addEventListener('click', function () {
            if ($element.classList.contains('is-open')) {
                $element.classList.remove('is-open');
            } else {
                $element.classList.add('is-open');
            }
        });
    }
};


window.addEventListener('load', function () {
    oy.navTabs.init();
}, false);